module.exports = __webpack_public_path__ + "static/media/B5.28cb1e03.wav";